import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from "recharts"
const Chart = ({ weightsData, weightUnit, activeTimeId }) => {
  
  function formatData(weightData) {
    const formattedData = [];
    for (const dataItem of weightData) {
      const dateObj = new Date(dataItem.date);
      const formattedDate = dateObj.toDateString();
      formattedData.unshift({
        'date': formattedDate,
        'weight': dataItem.weight.toFixed(1),
        'dateLocale': dateObj.toLocaleString()
      });
    }
    return formattedData;
  }

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="customTooltip">
          <p className="tooltipDate">{payload[0].payload.dateLocale}</p>
          <p className="tooltipWeight">{`Weight: ${payload[0].value}`}</p>
        </div>
      );
    }
    return null;
  }

  const getTickFormatter = (tick) => {
    const tickDate = new Date(tick);
    switch(activeTimeId) {
      case 'year':
        return tickDate.toLocaleString('en-US', {month:'numeric', day:'numeric'});
      case 'month':
        return tickDate.toLocaleString('en-US', {month:'short', day:'numeric'});
      case 'week':
        return tickDate.toLocaleString('en-US', {weekday:'long'})
      default:
        // alltime data in format "${month_short} '${year_2_digit}"
        const dateString = tickDate.toLocaleString('en-US', {month:'short'}).concat(" '", tickDate.toLocaleString('en-US', {year:'2-digit'}));
        return dateString;
    }
  }

  return (
    <div className='chart'>
      <ResponsiveContainer width="99%" height="100%">
        <LineChart data={formatData(weightsData)} margin={{ top: 30, right: 30, left: 30, bottom: 30 }}>
          <Line type="monotone" dataKey="weight" stroke="#8884d8" />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis dataKey="date" stroke="#e6e6e6" tickFormatter={getTickFormatter}/>
          <YAxis type="number" stroke="#e6e6e6" domain={['auto', 'auto']} unit={weightUnit}/>
          <Tooltip content={<CustomTooltip/>}/>
        </LineChart>     
      </ResponsiveContainer>
    </div>
    
  )
}

export default Chart